export default __webpack_public_path__ + "static/media/DiscussOpenly.5a6413b1.png";